import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
    password: Yup.string().min(3, 'Too Short!').required('Password is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
});